import { combineReducers } from 'redux'
import { withReduxStateSync } from 'redux-state-sync'
import { namespace as activityNamespace } from './activity'
import activityReducer from './activity/reducer'
import { namespace as activityLogNamespace } from './activityLog'
import activityLogReducer from './activityLog/reducer'
import { namespace as activityTickerNamespace } from './admin/activityTicker'
import activityTickerReducer from './admin/activityTicker/reducer'
import { namespace as aggressAttemptNamespace } from './admin/aggressAttempt'
import aggressAttemptReducer from './admin/aggressAttempt/reducer'
import { namespace as bbmIsinNamespace } from './admin/bbmisin'
import bbmIsinReducer from './admin/bbmisin/reducer'
import { namespace as tickerRatingNamespace } from './admin/tickerRating'
import tickerRatingReducer from './admin/tickerRating/reducer'
import { namespace as externalLiquidityStatsNamespace } from './admin/externalLiquidityStats'
import externalLiquidityStatsReducer from './admin/externalLiquidityStats/reducer'
import { namespace as managementReportsNamespace } from './admin/managementReports'
import managementReportsReducer from './admin/managementReports/reducer'
import { namespace as queueStatsNamespace } from './admin/queueStats'
import queueStatsReducer from './admin/queueStats/reducer'
import { namespace as restrictedTradesNamespace } from './admin/restrictedTrades'
import restrictedTradesReducer from './admin/restrictedTrades/reducer'
import { namespace as systemParamNamespace } from './admin/sysparam'
import systemParamReducer from './admin/sysparam/reducer'
import { namespace as tiersNamespace } from './admin/tiers'
import tiersReducer from './admin/tiers/reducer'
import { namespace as userDashboardNamespace } from './admin/userDashboard'
import userDashboardReducer from './admin/userDashboard/reducer'
import { namespace as userDataNamespace } from './admin/userData'
import userDataReducer from './admin/userData/reducer'
import { namespace as venueNamespace } from './admin/venues'
import venueReducer from './admin/venues/reducer'
import { namespace as alertFiltersNamespace } from './alertFilter'
import alertFiltersReducer from './alertFilter/reducer'
import { namespace as alertsNamespace } from './alerts'
import alertsReducer from './alerts/reducer'
import { namespace as authNamespace } from './auth'
import authReducer from './auth/reducer'
import { namespace as benchmarkDataNamespace } from './benchmarkData'
import benchmarkDataReducer from './benchmarkData/reducer'
import { namespace as booksNamespace } from './books'
import booksReducer from './books/reducer'
import { namespace as checkedOrdersNamespace } from './checkedOrders'
import checkedOrdersReducer from './checkedOrders/reducer'
import { namespace as customersNamespace } from './customers'
import customersReducer from './customers/reducer'
import { namespace as issuerNamespace } from './depthOfMarket'
import depthOfMarketReducer from './depthOfMarket/reducer'
import { namespace as gridNamespace } from './grid'
import gridReducer from './grid/reducer'
import { composeReducers } from './helpers'
import { namespace as listTradingNamespace } from './listTrading'
import { reducer as listTradingReducer } from './listTrading/reducer'
import { namespace as logNamespace } from './log'
import logReducer from './log/reducer'
import { namespace as marketNamespace } from './market'
import marketReducer from './market/reducer'
import { namespace as orderNamespace } from './order'
import orderReducer from './order/reducer'
import { namespace as passiveOrdersNamespace } from './passiveOrders'
import passiveOrdersReducer from './passiveOrders/reducer'
import { namespace as rfqNamespace } from './rfq'
import rfqReducer from './rfq/reducer'
import { namespace as searchSecuritiesNamespace } from './searchSecurities'
import searchSecuritiesReducer from './searchSecurities/reducer'
import { namespace as securitiesNamespace } from './securities'
import securitiesReducer from './securities/reducer'
import { namespace as settingsNamespace } from './settings'
import { globalSettingsReducer, settingsReducer } from './settings/reducer'
import { namespace as stagedOrdersNamespace } from './stagedOrders'
import stagedOrdersReducer from './stagedOrders/reducer'
import { namespace as toastsNamespace } from './toasts'
import toastsReducer from './toasts/reducer'
import { namespace as tradeBlotterNamespace } from './tradeBlotter'
import tradeBlotterReducer from './tradeBlotter/reducer'
import { namespace as windowFrameNamespace } from './windowFrame'
import windowFrameReducer from './windowFrame/reducer'
import { namespace as uploadNamespace } from './upload'
import uploadReducer from './upload/reducer'
import { namespace as userEditorDataNamespace } from './userEditorData'
import userEditorDataReducer from './userEditorData/reducer'
import { namespace as userPreferencesNamespace } from './userPreferences'
import { reducer as userPreferencesReducer } from './userPreferences/reducer'
import { namespace as usersNamespace } from './users'
import usersReducer from './users/reducer'
import { namespace as watchListNamespace } from './watchList'
import { reducer as watchListReducer } from './watchList/reducer'
import { namespace as webSettingsNamespace } from './webSettings'
import webSettingsReducer from './webSettings/reducer'
import { namespace as windowsNamespace } from './windows'
import windowsReducer from './windows/reducer'
import { namespace as websocketNamespace } from './ws'
import websocketReducer from './ws/reducer'

const reducer = composeReducers(
  combineReducers({
    [activityNamespace]: activityReducer,
    [activityLogNamespace]: activityLogReducer,
    [activityTickerNamespace]: activityTickerReducer,
    [aggressAttemptNamespace]: aggressAttemptReducer,
    [alertFiltersNamespace]: alertFiltersReducer,
    [alertsNamespace]: alertsReducer,
    [authNamespace]: authReducer,
    [bbmIsinNamespace]: bbmIsinReducer,
    [benchmarkDataNamespace]: benchmarkDataReducer,
    [booksNamespace]: booksReducer,
    [checkedOrdersNamespace]: checkedOrdersReducer,
    [customersNamespace]: customersReducer,
    [issuerNamespace]: depthOfMarketReducer,
    [externalLiquidityStatsNamespace]: externalLiquidityStatsReducer,
    [gridNamespace]: gridReducer,
    [listTradingNamespace]: listTradingReducer,
    [logNamespace]: logReducer,
    [managementReportsNamespace]: managementReportsReducer,
    [marketNamespace]: marketReducer,
    [orderNamespace]: orderReducer,
    [passiveOrdersNamespace]: passiveOrdersReducer,
    [queueStatsNamespace]: queueStatsReducer,
    [restrictedTradesNamespace]: restrictedTradesReducer,
    [rfqNamespace]: rfqReducer,
    [searchSecuritiesNamespace]: searchSecuritiesReducer,
    [securitiesNamespace]: securitiesReducer,
    [settingsNamespace]: settingsReducer,
    [stagedOrdersNamespace]: stagedOrdersReducer,
    [systemParamNamespace]: systemParamReducer,
    [tickerRatingNamespace]: tickerRatingReducer,
    [tiersNamespace]: tiersReducer,
    [toastsNamespace]: toastsReducer,
    [tradeBlotterNamespace]: tradeBlotterReducer,
    [windowFrameNamespace]: windowFrameReducer,
    [uploadNamespace]: uploadReducer,
    [userPreferencesNamespace]: userPreferencesReducer,
    [userDashboardNamespace]: userDashboardReducer,
    [userDataNamespace]: userDataReducer,
    [userEditorDataNamespace]: userEditorDataReducer,
    [usersNamespace]: usersReducer,
    [venueNamespace]: venueReducer,
    [watchListNamespace]: watchListReducer,
    [webSettingsNamespace]: webSettingsReducer,
    [windowsNamespace]: windowsReducer,
    [websocketNamespace]: websocketReducer
  }),
  globalSettingsReducer
)
export default withReduxStateSync(reducer)
